import React, { useCallback } from 'react';
import { Button } from '@hpstellar/core/visId';

import ProductQuickview from './product-quick-view-modal';

import './product-quick-view.less';

export default ({ product, images, children, analyticsData, options }) => {
    const [visible, setVisible] = React.useState(false);
    const onClick = useCallback(event => {
        setVisible(true);
    });

    return (
        <>
            {children ? (
                children({ onClick })
            ) : (
                <>
                    {' '}
                    <div className="quick-view-button">
                        <Button onClick={onClick} size="large" theme="light" variation="primary">
                            Quick view
                        </Button>
                    </div>
                </>
            )}
            {visible && (
                <ProductQuickview
                    product={product}
                    images={images}
                    isMobile={false}
                    visible={visible}
                    setVisible={setVisible}
                    analyticsData={analyticsData}
                    options={options}
                />
            )}
        </>
    );
};
